import { Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import s from "./OfflineBanner.module.css";

export function OfflineBanner() {
  const { t } = useTranslation("client");
  return (
    <div className={s.root} role="status">
      <Text size="sm" weight="medium">
        {t("offlineBanner.message", "Ei verkkoyhteyttä. Osa sisällöstä voi puuttua.")}
      </Text>
    </div>
  );
}
